import { Navigate } from 'react-router-dom'

import { isPreviewFrontend } from '@/lib/productionHost'

interface StagingOnlyProps {
  children: React.ReactNode
}

/** Renders children on staging and local. Production visitors go to dashboard. */
export function StagingOnly({ children }: StagingOnlyProps) {
  if (isPreviewFrontend()) {
    return <>{children}</>
  }
  return <Navigate to="../dashboard" replace />
}
